/**
 * Sprachen v1.0 (ARCHITEKTUR §10.4). Deutsch ist Quellsprache und Standard der Oberfläche.
 * `endonym` = Sprachname in der eigenen Sprache (für die Sprachkacheln, ohne Flaggen – F11).
 */
export const LOCALES = ["de", "en", "tr", "ar", "ru", "uk", "pl", "ro", "it", "es", "fr", "fa"] as const;
export type Locale = (typeof LOCALES)[number];

export const SOURCE_LOCALE: Locale = "de";

export interface LocaleInfo {
  code: Locale;
  endonym: string;
  dir: "ltr" | "rtl";
  /** Schriftsystem – steuert den Font-Stack */
  script: "latin" | "cyrillic" | "arabic";
}

export const LOCALE_INFO: Record<Locale, LocaleInfo> = {
  de: { code: "de", endonym: "Deutsch", dir: "ltr", script: "latin" },
  en: { code: "en", endonym: "English", dir: "ltr", script: "latin" },
  tr: { code: "tr", endonym: "Türkçe", dir: "ltr", script: "latin" },
  ar: { code: "ar", endonym: "العربية", dir: "rtl", script: "arabic" },
  ru: { code: "ru", endonym: "Русский", dir: "ltr", script: "cyrillic" },
  uk: { code: "uk", endonym: "Українська", dir: "ltr", script: "cyrillic" },
  pl: { code: "pl", endonym: "Polski", dir: "ltr", script: "latin" },
  ro: { code: "ro", endonym: "Română", dir: "ltr", script: "latin" },
  it: { code: "it", endonym: "Italiano", dir: "ltr", script: "latin" },
  es: { code: "es", endonym: "Español", dir: "ltr", script: "latin" },
  fr: { code: "fr", endonym: "Français", dir: "ltr", script: "latin" },
  fa: { code: "fa", endonym: "فارسی", dir: "rtl", script: "arabic" },
};

export const isLocale = (v: unknown): v is Locale =>
  typeof v === "string" && (LOCALES as readonly string[]).includes(v);

/** Wählt die beste unterstützte Sprache aus einer Präferenzliste (z. B. navigator.languages). */
export function negotiateLocale(preferred: readonly string[], fallback: Locale = SOURCE_LOCALE): Locale {
  for (const p of preferred) {
    const base = p.toLowerCase().split(/[-_]/)[0];
    if (isLocale(base)) return base;
  }
  return fallback;
}
